/**
 * swak-mega-trigger.js
 * Task 15 — Wire homepage CTAs to open Room Essentials / Care Packages mega menu
 * Updated 05/18/26 — event delegation, desktop mega menu, mobile scroll-to-top
 */

(function () {
  'use strict';

  function findMegaMenuTrigger(label) {
    const triggers = document.querySelectorAll('a[aria-haspopup="true"]');
    for (const el of triggers) {
      if (el.textContent.trim().toLowerCase() === label.toLowerCase()) {
        return el;
      }
    }
    return null;
  }

  function closeAllDropdowns() {
    document.querySelectorAll('a[aria-haspopup="true"]').forEach(function (el) {
      el.setAttribute('aria-expanded', 'false');
    });
  }

  function openMegaMenu(label) {
    const trigger = findMegaMenuTrigger(label);
    if (!trigger) {
      console.warn('[SWAK] Nav trigger not found for:', label);
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(function () {
      closeAllDropdowns();
      trigger.setAttribute('aria-expanded', 'true');
      trigger.focus({ preventScroll: true });
    }, 450);
  }

  function init() {
    // Event delegation — catches clicks regardless of DOM load order
    document.addEventListener('click', function (e) {
      const el = e.target.closest('[data-swak-trigger]');
      if (!el) return;

      const trigger = el.getAttribute('data-swak-trigger');
      e.preventDefault();

      if (window.innerWidth >= 768) {
        if (trigger === 'room-essentials') openMegaMenu('Room Essentials');
        if (trigger === 'care-packages') openMegaMenu('Care Packages');
      }
      // Mobile: no-op — CTA text instructs user to tap menu
    });

    // Auto-trigger from URL param on desktop (interior page footer links)
    if (window.innerWidth >= 768) {
      const urlParams = new URLSearchParams(window.location.search);
      const triggerParam = urlParams.get('swak-trigger');
      if (triggerParam === 'room-essentials') {
        setTimeout(function () { openMegaMenu('Room Essentials'); }, 600);
      } else if (triggerParam === 'care-packages') {
        setTimeout(function () { openMegaMenu('Care Packages'); }, 600);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
